<template>
  <div class="delete-faq">
    <h1>{{ $t('delete_confirm') }}</h1>
    <div class="button-container">
      <button class="button-submit delete-btn" type="submit" @click="deleteFaq">
        {{ $t('delete') }}
      </button>

      <router-link class="faq-add" to="/faqs">
        <button class="button-submit delete-btn" type="submit">
          {{ $t('cancel') }}
        </button>
      </router-link>
    </div>
    <div class="error">{{ this.error_message }}</div>
    <div class="success">{{ this.success_message }}</div>
  </div>
</template>

<script>
import { api } from '@/api';
import { errorHandler } from '@/mixins';

export default {
  name: 'FaqDelete',
  components: {},
  mixins: [errorHandler],
  data() {
    return {
      faqId: this.$route.params.id,
      error_message: '',
      success_message: ''
    };
  },
  methods: {
    deleteFaq() {
      api
        .delete(`/faqs/${this.faqId}`)
        .then((res) => {
          if (!res || res.error || res.message) {
            this.error_message = 'Failed to delete faq';
            return;
          }
          this.success_message = 'Faq deleted successfully';
          window.setTimeout(this.redirectToFaqs, 1000);
        })
        .catch((error) => {
          console.error('error', error);
          this.error_message = 'Failed to delete collection';
        });
    },
    redirectToFaqs() {
      window.location.href = `${window.location.origin}/faqs`;
    }
  }
};
</script>

<style lang="scss">
.button-container {
  display: flex;
  justify-content: space-between;
}

.delete-btn:hover {
  cursor: pointer;
}

.delete-faq {
  &__line {
    display: flex;
  }

  .error {
    margin-top: 20px;
    color: red;
  }

  .success {
    margin-top: 20px;
    color: green;
  }
}
</style>
